module.exports = __webpack_public_path__ + "img/oil_paint_large_4.69564ba1.png";